import { render, staticRenderFns } from "./NewServiceModal.vue?vue&type=template&id=6ec3261a"
import script from "./NewServiceModal.vue?vue&type=script&lang=js"
export * from "./NewServiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports